import React, { useEffect, useRef } from "react";
import { Reveal } from "../shared/Reveal";

export default function IntelligenceGraphic() {
  const ref = useRef(null);

  // Hide the floating Gap Analysis / WhatsApp buttons while this section is on screen
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => document.body.classList.toggle("ig-active", entry.isIntersecting),
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => {
      obs.disconnect();
      document.body.classList.remove("ig-active");
    };
  }, []);

  return (
    <section id="how-it-works" className="intel-graphic" data-testid="intelligence-graphic" ref={ref}>
      <div className="wrap ig-wrap">
        <Reveal className="eyebrow" tag="div">HOW IT WORKS</Reveal>
        <Reveal className="ig-title" tag="h2">
          UNDERSTAND THE INTELLIGENCE <span className="g">BEHIND THE BUILDING</span>
        </Reveal>
        <Reveal className="ig-intro" tag="p">
          Energy Vault Group designs and delivers the <b>Integrated Energy Intelligence Architecture</b> that transforms static buildings into <b>intelligent buildings</b> — connecting every asset, system and data stream, from individual equipment to the boardroom, through <span className="g">one intelligent infrastructure</span>.
        </Reveal>
        <Reveal tag="div" className="ig-frame">
          <img
            src="/brand/iea-architecture.jpg"
            alt="Integrated Energy Intelligence Architecture — the Digital Nervous System connects the building's electrical distribution, HVAC, refrigeration, lighting, water, pumps, controls, equipment assets, communications and people; the architecture analyses, detects, prioritises, applies human oversight, acts and verifies — turning data into intelligence and action."
            loading="lazy"
          />
        </Reveal>
        <div className="ig-qa">
          <Reveal tag="div" className="ig-qa-card">
            <div className="ig-qa-q">What is the Digital Nervous System?</div>
            <p>The real-time data foundation that connects systems, assets, utilities and people — making the building visible.</p>
          </Reveal>
          <Reveal tag="div" className="ig-qa-card">
            <div className="ig-qa-q">What is the Integrated Energy Intelligence Architecture?</div>
            <p>The complete operating model that turns those connections into intelligence, preventative action and continuously verified performance.</p>
          </Reveal>
        </div>
        <Reveal className="ig-statement" tag="p">
          One building. Many systems. <span className="g">One intelligence layer.</span>
        </Reveal>
        <Reveal className="ig-concl" tag="p">
          The DNS connects the building.<br />
          <span className="g">The Architecture turns connection into intelligence and action.</span>
        </Reveal>
        <Reveal tag="div" className="ig-cta">
          <a href="#what" className="btn ig-btn" data-testid="ig-cta">Explore Our Architecture</a>
        </Reveal>
      </div>
    </section>
  );
}
